import React, { ReactNode } from 'react';
import styles from './layout.scss';
import { Navbar } from '@/components/diffComponents';

export interface ILayoutProps {
  children: ReactNode;
  onLangChange?: () => Promise<boolean>;
}

const Layout: React.FC<ILayoutProps> = props => {
  const { children, onLangChange } = props;
  return (
    <div className="w-full h-full">
      <Navbar onLangChange={onLangChange} />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default Layout;
